import { render, staticRenderFns } from "./priceInput.vue?vue&type=template&id=4a04f3da&scoped=true"
import script from "./priceInput.vue?vue&type=script&lang=js"
export * from "./priceInput.vue?vue&type=script&lang=js"
import style0 from "./priceInput.vue?vue&type=style&index=0&id=4a04f3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a04f3da",
  null
  
)

export default component.exports